import React from 'react';
import { MediaCaptions } from '~/ui/video-player/MediaCaptions';
import { useMediaPlayer } from '~/ui/video-player/useMediaPlayer';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { AUDIO } from '../itemIds';
import { useEditorStore } from '~/shell/Store';
import { select } from '~/lib/select';
import { TrainingState, useTrainingStore } from '~/training/state';

interface Props {
  mediaUrl: string;
  subtitlesUrl?: string;
  autoPlay?: boolean;
}

const selectorUserSettings = (s: TrainingState) => select(s, 'autoPlay');

export type AudioDefinition = ItemDefinition<typeof AUDIO, Props>;

export class Audio extends Item<typeof AUDIO, Props> {
  protected render({ mediaUrl, subtitlesUrl, autoPlay }: RenderProps<Props>) {
    const { editorMode } = useEditorStore();
    // `autoPlay` is the author's setting for this slide; the learner's own
    // Auto Play toggle applies on top of it, same as in Video.
    const { autoPlay: autoPlayFromSetting } =
      useTrainingStore(selectorUserSettings);

    useMediaPlayer(
      mediaUrl,
      'audio',
      subtitlesUrl,
      editorMode ? false : Boolean(autoPlay && autoPlayFromSetting)
    );
    return <MediaCaptions />;
  }
}

registry[AUDIO] = Audio;
